import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: 'https://0b880ac156fb99a6529807c9922ce8b7@o4504258329968640.ingest.us.sentry.io/4511268628135936',
  tracesSampleRate: 1.0,
  debug: false,
  integrations: [],
})
